import * as React from "react";
import { PrimaryTooltip } from "Components/Shared/PrimaryTooltip";
import { PrimaryModal } from "Components/Shared/PrimaryModal";
import { TrashCanIcon } from "Components/Shared/Icons/TrashCanIcon";
import { Resources, useResource } from "Translations/Resources";
import { Typography } from "@material-ui/core";
import { EmployeeDto } from "Api/Api";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { deleteHumanResourcesEmployeeAsync } from "State/HumanResources/HumanResourcesReducer";
import { useHistory } from "react-router-dom";

type Props = {
  employee: EmployeeDto | null;
};

const StyledModalBody = styled.div`
  margin-bottom: ${props => props.theme.spacing(4)}px;

  & > * {
    &:last-of-type {
      font-weight: 500;
    }
  }
`;

export const EmployeeDetailConfirmModal: React.FunctionComponent<Props> = props => {
  const { employee } = props;
  const { t } = useResource();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [isDeleted, setDeleted] = React.useState(false);

  React.useEffect(() => {
    if (isDeleted) {
      redirectToEmployeeList();
    }
    // eslint-disable-next-line
  }, [isDeleted]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    if (employee) {
      dispatch(deleteHumanResourcesEmployeeAsync.request(employee.employeeID));
      setDeleted(true);
    }
  };

  const redirectToEmployeeList = () => {
    history.replace(`/${t(Resources.Routes.Employees)}`);
  };

  return (
    <>
      <PrimaryModal
        open={open}
        onClose={handleClose}
        onSuccess={handleSuccess}
        successBtnText={t(Resources.Common.Delete)}
        closeBtnText={t(Resources.Common.Cancel)}
        title={t(Resources.HumanResources.Employees.Detail.Delete.ConfirmTitle)}
      >
        <StyledModalBody>
          <Typography>
            {t(Resources.HumanResources.Employees.Detail.Delete.ConfirmText)}
          </Typography>
          <Typography>{`${employee?.firstName} ${employee?.lastName}`}</Typography>
        </StyledModalBody>
      </PrimaryModal>
      <PrimaryTooltip
        title={t(Resources.HumanResources.Employees.Detail.Delete.Label)}
      >
        <button className={"bl-btn bl-btn-orange"} onClick={_ => setOpen(true)}>
          <TrashCanIcon fill={"#ffffff"} />
        </button>
      </PrimaryTooltip>
    </>
  );
};
